















import { DataTable, EpbSwitch } from '../../components';

import { KpiEnum } from '../../enums';

import { capitalizeSentence } from '../../filters';

interface KpiDataItem {
  id: KpiEnum;
  label: string;
  enabled: boolean;
}

export default {
  name: 'kpis-form',
  props: {
    instance: {
      type: Object,
      required: true
    }
  },
  components: {
    DataTable,
    EpbSwitch
  },
  computed: {
    data: function (): KpiDataItem[] {
      return Object.values(KpiEnum).map((kpi: KpiEnum) => {
        const kpiString = ((kpi === KpiEnum.NO_RESULTS) ? 'noResults' : kpi); // TODO: avoid Enum translate
        return {
          id: kpi,
          label: this.getKpiMessage(kpi),
          enabled: this.instance.kpis.includes(kpiString)
        };
      });
    }
  },
  data: function () {
    return {
      columns: [
        {
          id: 'label',
          text: this.$epb.messages.tools.instances.fields.kpis.fields.id.label
        },
        {
          id: 'enabled',
          width: '8rem'
        }
      ]
    };
  },
  methods: {
    getKpiMessage: function (kpi: KpiEnum): string {
      const kpisMessages = this.$epb.messages.analytics.kpis;
      const kpiMessage = {
        [KpiEnum.QUERIES]: () => kpisMessages[KpiEnum.QUERIES].valueLabel,
        [KpiEnum.CLICKS]: () => kpisMessages[KpiEnum.CLICKS].percentageLabel,
        [KpiEnum.FINDABILITY]: () => kpisMessages[KpiEnum.FINDABILITY].valueLabel,
        [KpiEnum.ADD2CART]: () => kpisMessages[KpiEnum.ADD2CART].valueLabel,
        [KpiEnum.CHECKOUT]: () => kpisMessages[KpiEnum.CHECKOUT].valueLabel,
        [KpiEnum.NO_RESULTS]: () => kpisMessages['noResults'].valueLabel,
        [KpiEnum.SESSIONS]: () => kpisMessages[KpiEnum.SESSIONS].valueLabel,
        [KpiEnum.QUERIES_PER_SESSION]: () => kpisMessages[KpiEnum.QUERIES_PER_SESSION].valueLabel
      }[kpi]();
      return capitalizeSentence(kpiMessage);
    },
    setKpiEnabled: function (kpi: KpiEnum, enabled: boolean): void {
      const kpiString = ((kpi === KpiEnum.NO_RESULTS) ? 'noResults' : kpi); // TODO: avoid Enum translate
      if (enabled) {
        this.instance.kpis.push(kpiString);
      } else {
        const indexOfKpi = this.instance.kpis.indexOf(kpiString);
        this.instance.kpis.splice(indexOfKpi, 1);
      }
    }
  }
};
